export default __webpack_public_path__ + "static/media/HND.0fff97c7.svg";